import { render } from "./NewsMaster.vue?vue&type=template&id=a954116e&scoped=true"
import script from "./NewsMaster.vue?vue&type=script&lang=js"
export * from "./NewsMaster.vue?vue&type=script&lang=js"

import "./NewsMaster.vue?vue&type=style&index=0&id=a954116e&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a954116e"]])

export default __exports__